module.exports = __webpack_public_path__ + "img/kt-knight-right.66acf5e1.png";